import React from 'react';
import Footer from '../components/Footer';
import AffiliateLink from '../components/AffiliateLink';
import AddToCartButton from '../components/AddToCartButton';
import PaymentCards from '../components/PaymentCards';
import ProductBundle from '../components/ProductBundle';
import GuaranteeBadge from '../components/GuaranteeBadge';
import WatchNowButton from '../components/WatchNowButton';
import { images, testimonials, faqs, benefits, systemFeatures, mainPageContent, AFFILIATE_URL } from '../data/mock';

const TSLPage = () => {
  const handlePageClick = (e) => {
    if (e.target.closest('footer') || e.target.closest('a') || e.target.closest('button') || e.target.closest('header') || e.target.closest('nav')) {
      return;
    }
    window.open(AFFILIATE_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen flex flex-col bg-white" onClick={handlePageClick}>
      {/* Header with red bar */}
      <header className="w-full">
        <div className="w-full h-2 bg-[#cc0000]" aria-hidden="true" />
      </header>
      
      <main className="flex-1 cursor-pointer">
        <article className="max-w-3xl mx-auto px-4 py-8" itemScope itemType="https://schema.org/Article">
          
          {/* H1 - Main Headline - Only one per page */}
          <AffiliateLink>
            <h1 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-8 leading-tight" itemProp="headline">
              Energy Revolution System: Tesla's Long-Lost Invention to Save Electricity and Dollars
            </h1>
          </AffiliateLink>

          {/* Introduction Section */}
          <section aria-labelledby="intro-section">
            <h2 id="intro-section" className="sr-only">Introduction to Energy Revolution System</h2>
            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>Hi, My name is Michael Garnett,</p>
              
              <p>
                And I'm going to expose to you the untold truth behind <strong>Nikola Tesla's lab FIRE...</strong> after he patented the <strong>model no 512,340 on January 9th, 1894</strong> that was meant to change the energy revolution forever...
              </p>
              
              <p>
                And how he was forced to quit on all the projects that would have meant your energy independence today... losing $50,000, all his work and the right to win the Nobel prize for energy.
              </p>
            </div>

            {/* First Image - Save Energy Concept */}
            <figure className="mb-8">
              <AffiliateLink className="block">
                <img 
                  src={images.img1} 
                  alt="Energy Revolution System helps you save dollars on electricity bills - calculator showing savings" 
                  className="w-full max-w-lg mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                  loading="lazy"
                  width="600"
                  height="400"
                />
              </AffiliateLink>
              <WatchNowButton />
              <figcaption className="sr-only">Calculate how much you can save on electricity with Energy Revolution System</figcaption>
            </figure>

            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>
                You're also going to discover the sweet revenge of Tesla on the greedy energy fat cats... 2 weeks before he passed away by exposing ONLY to his natal villagers an <strong>invention that costs $63</strong> and takes <strong>43 minutes to build</strong> and that has cut their electricity bill <strong>instantly by 80%...</strong> for the past 78 years... <strong>totally legal!</strong>
              </p>
              
              <p>
                And if you stick with me until the end of this <strong>shocking but very short video,</strong> that the power companies would pay a fortune to take it down...
              </p>
              
              <p>
                I'll show how you, like other {mainPageContent.familiesCount} people who took action, can pay as less as $20 instead of $100 or $50 instead of $250 on your monthly electricity bills... <strong>for the rest of your life.</strong>
              </p>
            </div>
          </section>

          {/* Tesla Story Section */}
          <section aria-labelledby="tesla-story">
            <h2 id="tesla-story" className="sr-only">The Tesla Energy Revolution Story</h2>
            
            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>
                July 10th, 1856 – in the small village of Smiljan (Croatia today)... from a father priest and a mother artist Nikola Tesla was born.
              </p>
            </div>

            <figure className="mb-8">
              <AffiliateLink className="block">
                <img 
                  src={images.img2} 
                  alt="Nikola Tesla - inventor of Tesla Energy Revolution technology to save electricity" 
                  className="w-full max-w-md mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                  loading="lazy"
                  width="440"
                  height="600"
                />
              </AffiliateLink>
              <WatchNowButton />
              <figcaption className="sr-only">Nikola Tesla, the genius behind the Energy Revolution System</figcaption>
            </figure>

            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>From early childhood the boy proved to be a genius.</p>
              
              <p>
                Before going to elementary school Nikola amazed his parents: the obsession for making home craft tools, mechanical appliances and the ability to memorize Serbian epic poems were things that he was doing all day long at the age of 6.
              </p>
              
              <p>In school, he was always learning from 3 AM to 11 PM.</p>
              
              <p>No weekend or holidays and concerned even the professors that he might die from exhausting.</p>
              
              <p>For Nikola it was normal and he was having the time of his life.</p>
              
              <p>
                Soon he quits on school because he felt that he was not progressing and decides to come to the US and work for the great Thomas Edison in design and improvement to electrical equipment.
              </p>
              
              <p>
                Tesla makes his genius remarked shortly and tells Edison that he could redesign Edison's motors and generators, making an improvement in both service and economy.
              </p>
            </div>

            <figure className="mb-8">
              <AffiliateLink className="block">
                <img 
                  src={images.img3} 
                  alt="Thomas Edison - Tesla's rivalry led to energy revolution breakthroughs" 
                  className="w-full max-w-md mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                  loading="lazy"
                  width="440"
                  height="600"
                />
              </AffiliateLink>
              <WatchNowButton />
              <figcaption className="sr-only">Thomas Edison, Tesla's employer and later rival</figcaption>
            </figure>

            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>Edison laughed and said:</p>
              
              <h3 className="font-bold text-xl text-center py-4">
                "There's fifty thousand dollars in it for you... if you can do it"
              </h3>
              
              <p>In 1882 ... $50,000 was the equivalent of $1.3 Million today.</p>
              
              <p>Tesla did it ultimately <strong>...</strong></p>
              
              <h3 className="font-bold text-xl text-[#cc0000]">But The First Betrayal knocked at his door.</h3>
              
              <p>
                Edison refused to pay him... saying <strong>"Tesla, you don't understand our American humor".</strong>
              </p>
              
              <p>
                Tesla resigned and founded his own company <strong>Tesla Electric Light & Manufacturing.</strong>
              </p>
              
              <p>
                The company installed electrical arc light based illumination systems and also had the designs for dynamo electric machine commutators, the first patents issued to Tesla in the US.
              </p>
              
              <h3 className="font-bold text-xl text-[#cc0000]">The Second Betrayal Occurred...</h3>
              
              <p>
                Tesla proposed that the company should go on to develop his ideas for alternating current transmission system and motors.
              </p>
              
              <p>
                The investors (big banks connected with the energy world at that time) disagree and fired him from his own company... leaving him penniless.
              </p>
              
              <p>Tesla was forced to work as a ditch digger for $2 per day.</p>
              
              <p>
                Later he said about that period that it was <strong>"terrible headaches and bitter tears".</strong>
              </p>
              
              <p>
                One year later, with the help of some attorney friend, Tesla formed the <strong>Tesla Electric Company.</strong>
              </p>
              
              <p>
                Over the next years his company constructed an <strong>alternating current induction motor</strong> based on a <strong>rotating</strong> magnetic field.
              </p>
            </div>

            <figure className="mb-8">
              <AffiliateLink className="block">
                <img 
                  src={images.img5} 
                  alt="AC Motor technology - foundation of Tesla Energy Revolution System to save energy" 
                  className="w-full max-w-md mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow bg-white p-4"
                  loading="lazy"
                  width="500"
                  height="400"
                />
              </AffiliateLink>
              <WatchNowButton />
              <figcaption className="sr-only">AC Motor technology that powers the Energy Revolution System</figcaption>
            </figure>

            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>He received patent for the motor in May 1888.</p>
              
              <p><strong>X-ray experimentation</strong> was next and then the radio waves.</p>
              
              <p>
                So next time you listen radio, or you go to your doctor for an x-ray or even when you're using the electrical stove or the microwave unit... make sure you know it comes from Tesla.
              </p>
            </div>

            <figure className="mb-8">
              <AffiliateLink className="block">
                <img 
                  src={images.img7} 
                  alt="Tesla's scientific innovations - X-ray technology for energy revolution" 
                  className="w-full max-w-md mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                  loading="lazy"
                  width="500"
                  height="400"
                />
              </AffiliateLink>
              <WatchNowButton />
              <figcaption className="sr-only">Tesla's X-ray experimentation advances</figcaption>
            </figure>

            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>But things were far from running smoothly and the day that was about to change everything came.</p>
              
              <p>
                <strong>January 9th, 1894.</strong> Nikola Tesla wakes up in the morning, takes all the documentation of a secret invention and heads to the US Patent Office.
              </p>
              
              <p>Four hours later he's getting out with a big smile on his face.</p>
              
              <p>Rumors say that he yelled</p>
              
              <h3 className="font-bold text-xl text-center py-4">
                "This will change the energy world forever".
              </h3>
              
              <p>
                For the next period he worked day and night to fulfill his dream... to make this genius invention applicable for all people.
              </p>
              
              <p>A few people know what I'm gonna tell you next...</p>
              
              <p>
                He needed funds and he invited in his laboratory 5 potential investors for a demonstration of his discovery.
              </p>
            </div>

            <figure className="mb-8">
              <AffiliateLink className="block">
                <img 
                  src={images.img6} 
                  alt="Tesla Laboratory where Energy Revolution System was developed to save electricity" 
                  className="w-full max-w-md mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                  loading="lazy"
                  width="600"
                  height="400"
                />
              </AffiliateLink>
              <WatchNowButton />
              <figcaption className="sr-only">Tesla's Laboratory - birthplace of the Energy Revolution</figcaption>
            </figure>

            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>
                Among these five people there were: two bankers, two energy investors and one president of a very powerful power company at that time.
              </p>
              
              <p>
                The "mad man scientist" took out of his bag a <strong>weird little device.</strong>
              </p>
              
              <p>He turned on a light bulb... and right next to it he put his little device...</p>
              
              <p>Then from this little device he plugged in another <strong>15 more light bulbs.</strong></p>
              
              <p>The result was incredible.</p>
              
              <p>
                From the same source of energy that was lighting one bulb... he managed, through his weird invention, to give power to <strong>15 more light bulbs.</strong>
              </p>
            </div>

            <figure className="mb-8">
              <AffiliateLink className="block">
                <img 
                  src={images.img12} 
                  alt="Energy Revolution System demonstration - save energy with Tesla's light bulb invention" 
                  className="w-full max-w-md mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                  loading="lazy"
                  width="600"
                  height="400"
                />
              </AffiliateLink>
              <WatchNowButton />
              <figcaption className="sr-only">Tesla's light bulb demonstration showing energy multiplication</figcaption>
            </figure>

            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>
                Bottom line was that for every 100 watts consumed he was able to get at least <strong>500 free watts.</strong>
              </p>
              
              <p>
                His incredible invention was about to cut the electricity bills... <strong>instantly, by 80% everywhere in the world.</strong>
              </p>
              
              <p>The assistance was in shock.</p>
              
              <p>They even searched the device to see if there are any gimmicks.</p>
              
              <p>Tesla said:</p>
              
              <h3 className="font-bold text-xl text-center py-4">
                "Gentlemen, finance me and help me improve this and all the planet will afford energy".
              </h3>
              
              <p>
                Although at the first sight they all looked interested, this invention hit them in the back of their head.
              </p>
              
              <p>
                These guys were making money from energy consumption and they were planning to expand.
              </p>
              
              <p>Their interest was to trick people to consume more instead of saving on energy.</p>
              
              <p>This could have meant their bankruptcy.</p>
              
              <p>
                Only Tesla was naive because he didn't care about money and he thought that all the other people are the same.
              </p>
              
              <p>Big mistake, because one week later</p>
              
              <h3 className="font-bold text-2xl text-[#cc0000] text-center py-4">
                The ULTIMATE Betrayal Occurred.
              </h3>
              
              <p>
                March 13th, 1895 – On the 5th Avenue at Tesla Laboratory a <strong>big fire started...</strong>
              </p>
              
              <p>In less than 2 hours the entire building burnt to the ground.</p>
              
              <p>Nikola Tesla barely escaped...</p>
            </div>

            <figure className="mb-8">
              <AffiliateLink className="block">
                <img 
                  src={images.img8} 
                  alt="Tesla Laboratory fire destroyed energy revolution research - save electricity secrets lost" 
                  className="w-full max-w-md mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                  loading="lazy"
                  width="500"
                  height="400"
                />
              </AffiliateLink>
              <WatchNowButton />
              <figcaption className="sr-only">The tragic fire that destroyed Tesla's laboratory</figcaption>
            </figure>

            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>
                Much of Tesla's early research, hundreds of invention models, plans, notes, laboratory data, tools, photographs, valued at $50,000 was lost in the 5th Avenue laboratory fire.
              </p>
              
              <p>Tesla is quoted by <em>The New York Times</em> as saying,</p>
              
              <h3 className="font-bold text-xl text-center py-4">
                "I am in too much grief to talk. What can I say?"
              </h3>
              
              <p>
                This devastated him and although he was pretty sure where that fire came from... he didn't go to police to press charges.
              </p>
              
              <p>
                He quit on everything, didn't care about science anymore, started to gamble and almost got broke.
              </p>
              
              <p>
                For the next period, he went in his natal village in Smiljan (Croatia) with all the papers that he could save and started a new life.
              </p>
            </div>

            <figure className="mb-8">
              <AffiliateLink className="block">
                <img 
                  src={images.img9} 
                  alt="Smiljan village Croatia - where Tesla's energy revolution secrets were preserved" 
                  className="w-full max-w-md mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                  loading="lazy"
                  width="600"
                  height="400"
                />
              </AffiliateLink>
              <WatchNowButton />
              <figcaption className="sr-only">Smiljan village in Croatia, Tesla's birthplace</figcaption>
            </figure>

            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>
                The truth is that Tesla never recovered mentally from this event and even though he continued his projects and research... he decided to quit on the project that was about to give very cheap energy to people.
              </p>
              
              <p>On January 7th, 1943 Tesla dies alone in a hotel room in New York.</p>
              
              <p>
                Power companies made sure that his name was forgotten and became popular again in the 1990's.
              </p>
              
              <p>
                Greedy energy fat cats believed that the secret of cheap electricity died along with Tesla, but they didn't know that he managed to <strong>save the plans of his invention</strong> and that he gave it away only to people of his natal village.
              </p>
              
              <p>
                Rumors say that Smiljan is the community where people are still paying <strong>less than 20%</strong> than other Croatians are paying.
              </p>
              
              <p>How do I know all these?</p>
              
              <p>Well... I lived in Smiljan for 4 years and I got to find all the secrets.</p>
              
              <p>Here are some pictures from Smiljan...</p>
              
              <p>Have a look and tell me if you see anything strange?</p>
              
              <p>
                As you can see there are electrical masts on the road, but houses don't seem to need electricity from the power companies.
              </p>
            </div>

            <figure className="mb-8">
              <AffiliateLink className="block">
                <img 
                  src={images.img10} 
                  alt="Power lines and electricity infrastructure - Energy Revolution System helps save dollars on bills" 
                  className="w-full max-w-md mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                  loading="lazy"
                  width="600"
                  height="400"
                />
              </AffiliateLink>
              <WatchNowButton />
              <figcaption className="sr-only">Village with power lines - homes using Tesla's energy saving technology</figcaption>
            </figure>
          </section>

          {/* Energy Revolution System Section */}
          <section aria-labelledby="system-details">
            <h2 id="system-details" className="sr-only">How the Energy Revolution System Works</h2>
            
            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>Now let me tell you what is all about and how it can change your life…</p>
              
              <p>
                This invention can work anywhere to power everything from small radios, to big refrigerators, plasma TVs or computers...
              </p>
              
              <p>
                It's perfect to use in <strong>any situation...</strong> especially in disaster situations when all the energy lines are down and you need electricity for preserving the food in refrigerator and for cooking.
              </p>
              
              <p>
                It's so small that you can put it into your pocket, but it's so powerful that it can reduce your entire electricity bill by <strong>80% instantly...</strong>
              </p>
              
              <p>
                The wonder invention is the <strong>Bifilar Pancake Coil</strong> patented by <strong>Nikola Tesla in 1894</strong> in the <strong>patent N° 512,340.</strong>
              </p>
            </div>

            <figure className="mb-8">
              <AffiliateLink className="block">
                <img 
                  src={images.img11} 
                  alt="Tesla Coil patent - Energy Revolution System technology to save electricity and dollars" 
                  className="w-full max-w-md mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                  loading="lazy"
                  width="500"
                  height="400"
                />
              </AffiliateLink>
              <WatchNowButton />
              <figcaption className="sr-only">Tesla's Bifilar Pancake Coil - the heart of Energy Revolution System</figcaption>
            </figure>

            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>
                And you can find this anywhere at any local shop, but just a few people know what to do with it.
              </p>
              
              <p>
                There's a catch... Tesla's invention was not yet ready to be a DIY when his lab got on fire.
              </p>
              
              <p>
                In fact those who put the fire on his lab wanted this and even though many people know about Tesla Coil and you can find info on a few websites, no one will teach you how to make this work for your home and how to cut your electricity prices <strong>by 80% guaranteed by tomorrow.</strong>
              </p>
              
              <p>
                Without insider info, that Tesla shared ONLY with villagers of Smiljan, you won't be able to do it.
              </p>
              
              <p>
                I'm going to show everything in a minute, but before this let me share with you what's so magic about this coil.
              </p>
              
              <p>
                The bifilar coil is a coil <strong>on steroids.</strong> Tesla believed that this comes from other planet and that is <strong>the best product this planet could give.</strong>
              </p>
              
              <p>
                Imagine a coil that has so much power that can last tens of years without any intervention, giving anytime the exact boost that a small source of electricity needs ... to transform itself into more electricity.
              </p>
            </div>

            <figure className="mb-8">
              <AffiliateLink className="block">
                <img 
                  src={images.teslaCoil} 
                  alt="Tesla Coil energy technology - save energy and reduce electricity bills with Energy Revolution System" 
                  className="w-full max-w-md mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow"
                  loading="lazy"
                  width="500"
                  height="400"
                />
              </AffiliateLink>
              <WatchNowButton />
              <figcaption className="sr-only">Tesla Coil technology in action</figcaption>
            </figure>

            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>
                This is not unique in nature... I don't know if you're familiar with how the aircraft carriers are built and how they're propelled, but for sure they're not working on gas or diesel.
              </p>
              
              <p>
                Their energy is provided by uranium and approximately 100 lbs of uranium is enough to propel a huge carrier for 1 year without interruption... around the globe.
              </p>
              
              <p>
                Pretty much same happens with Tesla coil, at a different proportion, it has the same power.
              </p>
              
              <p>
                It can boost any electricity source into <strong>5 times more... instantly, permanently, without any intervention... for the rest of your life.</strong>
              </p>
              
              <p>
                And in the next few moments, you're going to see you just how <strong>easy</strong> it is to build it yourself.
              </p>
              
              <p>
                But here's the <strong>even better news:</strong> many of the materials Tesla had in his original patents used to cost a small fortune when the inventor was alive…
              </p>
              
              <p>
                But after almost a century, you can find many of these components <strong>for mere dollars</strong> at any Home Depot…
              </p>
              
              <p>
                In fact, the new blueprints are so <strong>simple</strong>, that you don't have to be an electrician...
              </p>
              
              <p>
                Heck, a 12 year old could build a small generator <strong>during a lunch break!</strong>
              </p>
              
              <p>Just imagine having your entire home powered by Tesla energy...</p>
              
              <p>
                <strong>NO more paying</strong> through the nose on electricity... just to make the fat cats even fatter.
              </p>
              
              <p>
                Turn on the AC <strong>as often as you want</strong>... without having to constantly hear that nagging voice inside your head telling you that you need to turn it off because you'll end up paying a fortune
              </p>
              
              <h3 className="font-semibold">Here's a short video of the device in action:</h3>
            </div>

            {/* Video Section */}
            <figure className="mb-8">
              <AffiliateLink className="block">
                <div className="relative max-w-lg mx-auto bg-black rounded-lg overflow-hidden shadow-xl">
                  <img 
                    src={images.videoThumbnail} 
                    alt="Energy Revolution System video demonstration - learn how to save electricity and dollars" 
                    className="w-full opacity-90"
                    loading="lazy"
                    width="600"
                    height="400"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors" aria-label="Play video">
                      <div className="w-0 h-0 border-t-8 border-b-8 border-l-12 border-transparent border-l-white ml-1" style={{borderLeftWidth: '12px'}}></div>
                    </div>
                  </div>
                  <div className="absolute bottom-2 left-2 text-white text-sm">Energy Revolution System Demo</div>
                </div>
              </AffiliateLink>
              <WatchNowButton />
              <figcaption className="sr-only">Watch the Energy Revolution System in action</figcaption>
            </figure>

            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>
                Remember, this is the <strong>smallest scale</strong> at which you can build <strong>The Energy Revolution System.</strong>
              </p>
              
              <p>With larger scale devices the <strong>results are impressive.</strong></p>
            </div>
          </section>

          {/* Benefits Section */}
          <section aria-labelledby="benefits-heading" className="bg-gray-50 p-6 rounded-lg mb-8">
            <h2 id="benefits-heading" className="text-xl font-bold text-gray-800 mb-4">Benefits of Energy Revolution System - Save Energy & Dollars</h2>
            <ul className="space-y-4 text-gray-800 text-lg" role="list">
              {benefits.map((benefit, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="text-green-600 font-bold text-xl" aria-hidden="true">✓</span>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </section>

          <section aria-labelledby="more-benefits">
            <h2 id="more-benefits" className="sr-only">Additional Energy Revolution Benefits</h2>
            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>
                What's more... because <strong>The Energy Revolution System</strong> is very light and portable, it makes for one of the best <strong>"emergency"</strong> generators you could ever hope for.
              </p>
              
              <p>
                Unlike solar panels, it won't get blown off the roof by strong winds and hurricanes.
              </p>
              
              <p>
                And unlike conventional "portable" generators, there are <strong>no fumes</strong>... and you don't have to spend hundreds of dollars on fuel.
              </p>
              
              <p>In fact, there's very little to spend at all.</p>
              
              <p>
                Except from a simple maintenance check every few months, the generator is basically "<strong>Set And Forget</strong>".
              </p>
              
              <p>
                And because the low-friction design makes it <strong>so silent</strong>, you won't even hear it running!
              </p>
              
              <p>
                That's because you can install it in your basement, or in your back yard… and <strong>not worry</strong> about weather conditions for one second.
              </p>
            </div>
          </section>

          {/* Testimonials Section */}
          <section aria-labelledby="testimonials-heading">
            <h2 id="testimonials-heading" className="sr-only">Customer Reviews - Energy Revolution System Success Stories</h2>
            {testimonials.map((testimonial) => (
              <figure key={testimonial.id} className="mb-8">
                <AffiliateLink className="block">
                  <blockquote className="flex items-start gap-4 bg-gray-50 p-6 rounded-lg" itemScope itemType="https://schema.org/Review">
                    <img 
                      src={testimonial.image} 
                      alt={`${testimonial.name} - Energy Revolution System customer who saves dollars on electricity`}
                      className="w-20 h-20 rounded-full object-cover flex-shrink-0"
                      loading="lazy"
                      width="80"
                      height="80"
                    />
                    <div>
                      <p className="text-gray-700 italic text-lg mb-3" itemProp="reviewBody">
                        <em>{testimonial.text}</em>
                      </p>
                      <cite className="font-bold text-gray-800 not-italic" itemProp="author">
                        {testimonial.age && `${testimonial.age} `}{testimonial.name} from {testimonial.location}
                      </cite>
                    </div>
                  </blockquote>
                </AffiliateLink>
                <WatchNowButton />
              </figure>
            ))}
          </section>

          {/* Why Try Now Section */}
          <section aria-labelledby="why-try-now">
            <h2 id="why-try-now" className="font-bold text-xl mb-4">
              Why You Need To Try The Energy Revolution System Today
            </h2>
            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>
                Quite frankly, there's never been a better time for a technology like this to emerge.
              </p>
              
              <p>
                With electricity prices going through the roof, and "peak oil" just around the corner, it's only a matter of time before <strong>everyone turns to alternative energy sources.</strong>
              </p>
              
              <p>
                But if you <strong>think about it,</strong> you'll realize "alternative energy" never really was an alternative.
              </p>
              
              <p><strong>Just try</strong> to go solar without spending 5-figures on a solar panel system.</p>
              
              <p><strong>It's impossible</strong>.</p>
              
              <p>
                And then, there's maintenance costs… breakdowns… clouds… bird droppings…
              </p>
              
              <p>and all the stuff you just don't want to be worrying about.</p>
              
              <p>
                <strong>The Energy Revolution System</strong> on the other hand is extremely adaptable… and will completely <strong>change the way you look</strong> at energy:
              </p>
            </div>
          </section>

          {/* System Features Section */}
          <section aria-labelledby="features-heading" className="bg-gray-50 p-6 rounded-lg mb-8">
            <h2 id="features-heading" className="text-xl font-bold text-gray-800 mb-4">Energy Revolution System Features - Save Electricity Easily</h2>
            <ul className="space-y-4 text-gray-800 text-lg" role="list">
              {systemFeatures.map((feature, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="text-[#cc0000] font-bold" aria-hidden="true">•</span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* Offer Section */}
          <section aria-labelledby="offer-heading" className="text-center py-8 border-t-2 border-b-2 border-gray-200 my-8">
            <h2 id="offer-heading" className="text-2xl font-bold text-gray-800 mb-6">
              Get The Energy Revolution Blueprints - Start Saving Dollars Today
            </h2>
            
            <ProductBundle className="mb-6" />
            <WatchNowButton className="mb-6" />
            
            <div className="text-gray-800 text-lg leading-relaxed space-y-4 max-w-2xl mx-auto">
              <p>
                You need to <strong>move fast</strong> on this one, because we simply don't know for how long this website is going to stay up.
              </p>
              
              <p>
                The first time people heard about <strong>The Energy Revolution System,</strong> things turned out really bad for the inventor… and we fear it might happen once again
              </p>
              
              <p>
                But still… we want to <strong>get this into</strong> as many hands as possible.
              </p>
              
              <p>
                <strong>This is my PROMISE to you:</strong> if you use the over-the-shoulder guides, the step-by-step instructions, the illustrated blueprints, and the materials cheat-sheet I'm giving you…
              </p>
              
              <p>
                You will create an <strong>ultra-low maintenance, ultra efficient power generator</strong> that works just as well as your current power source.
              </p>
              
              <p>
                Having this system in your home will save you <strong>hundreds of dollars each month…</strong> and thousands each year…
              </p>
              
              <h3 className="text-xl">
                So I'm not going to ask you to invest $1,000 for this secret even though I know it's worth at least that.
              </h3>
              
              <p>
                It won't cost you $500, as Tesla envisioned it, either…
              </p>
              
              <p>
                Yet <strong>The Energy Revolution Blueprints</strong> won't cost you $500, not even $250 though they would be worth <strong>every penny</strong> at this price
              </p>
              
              <p>
                I'm going to set the price of <strong>The Energy Revolution Blueprints</strong> at just $69.
              </p>
              
              <p>
                But because you're getting here early, if you act <strong>right now</strong>, I'll let you have <strong>The Energy Revolution Blueprints,</strong> including the manual, the schematics, the parts list and all the step-by-step guides…
              </p>
              
              <p className="text-3xl font-bold text-[#cc0000] py-4">
                For a single payment of ONLY $39.00…
              </p>
              
              <p>
                That's probably less than half of what you're paying each month on electricity and you can <strong>recoup that investment</strong> in as little as 30 days…
              </p>
              
              <p>
                Getting the blueprints for <strong>The Energy Revolution System</strong> is easy!
              </p>
              
              <p>
                Just click the big, shiny, inviting "Add To Cart" button that just appeared below and you'll be taken to our secure order page.
              </p>
            </div>
            
            <div className="mt-8">
              <AddToCartButton />
              <div className="mt-4">
                <PaymentCards />
              </div>
            </div>
          </section>

          {/* Guarantee Section */}
          <section aria-labelledby="guarantee-heading" className="text-center py-8">
            <h2 id="guarantee-heading" className="sr-only">60 Day Money Back Guarantee</h2>
            <p className="text-gray-800 text-lg mb-4">
              You're covered by our "No Questions Asked Money Back Guarantee" for <strong>60 full days</strong>.
            </p>
            
            <GuaranteeBadge className="mb-6" />
            <WatchNowButton className="mb-6" />
            
            <div className="text-gray-800 text-lg leading-relaxed space-y-4 max-w-2xl mx-auto text-left">
              <p>It's simple:</p>
              
              <p><strong>Get the blueprints today</strong> and put them to the test…</p>
              
              <p><strong>See</strong> how easy it is to make your own electricity with <strong>The Energy Revolution System.</strong></p>
              
              <p><strong>Feel</strong> the peace of mind that comes with knowing you don't owe anyone a red cent.</p>
              
              <p>And see what's like to take your electricity bill down to almost nothing… by the end of the month.</p>
              
              <p>You have 60 days to decide whether this was a good investment or not!</p>
              
              <p>
                And if you're less than thrilled with how much you're saving on electricity, just write us a short email at the address you'll find in the members area…
              </p>
              
              <p>
                We'll give you an immediate refund – even if it's the 23rd hour of the 59th day
              </p>
            </div>
          </section>

          {/* Second CTA */}
          <aside className="text-center py-8">
            <p className="text-gray-800 text-lg mb-4">
              Just click the orange "Add To Cart" Button that you see below!
            </p>
            <AddToCartButton />
            <div className="mt-4">
              <PaymentCards />
            </div>
            <WatchNowButton className="mt-4" />
          </aside>

          {/* Final Push */}
          <section aria-labelledby="join-families">
            <h2 id="join-families" className="sr-only">Join Families Saving Electricity with Energy Revolution</h2>
            <div className="text-gray-800 text-lg leading-relaxed space-y-4 mb-8">
              <p>
                Join the 102,244 thrilled families who have realized that there is a better, simpler, and a more cost-effective way to power their homes…
              </p>
              
              <p>
                The bottom line is, you need to get in fast - while you can - to get your hands on this incredible technology.
              </p>
            </div>
          </section>

          {/* Third CTA */}
          <aside className="text-center py-8">
            <AddToCartButton />
            <div className="mt-4">
              <PaymentCards />
            </div>
            <WatchNowButton className="mt-4" />
          </aside>

          {/* FAQ Section */}
          <section aria-labelledby="faq-heading" className="py-8">
            <h2 id="faq-heading" className="text-2xl font-bold text-gray-800 mb-6">Frequently Asked Questions About Energy Revolution System</h2>
            <p className="text-gray-800 text-lg mb-6">
              There are some questions that I keep receiving from people, and I'll try to answer a few here.
            </p>
            
            <div itemScope itemType="https://schema.org/FAQPage">
              {faqs.map((faq, index) => (
                <div key={index} className="mb-6" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h3 className="text-xl font-bold text-gray-800 mb-2" itemProp="name">
                    {index + 1}. {faq.question}
                  </h3>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-gray-700 text-lg" itemProp="text">{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Final CTA */}
          <aside className="text-center py-8">
            <p className="text-gray-800 text-lg mb-4">
              So, go ahead and seize your opportunity now by clicking the orange "Add To Cart" button below.
            </p>
            <AddToCartButton />
            <div className="mt-4">
              <PaymentCards />
            </div>
            <WatchNowButton className="mt-4" />
          </aside>

          {/* Exit Offer */}
          <aside className="bg-yellow-50 border-2 border-yellow-400 rounded-lg p-6 text-center mt-8" aria-labelledby="exit-offer">
            <h3 id="exit-offer" className="text-2xl font-bold text-red-600 mb-2"># Wait! Save $10 Right Now!</h3>
            <p className="text-gray-800 text-lg mb-4">
              I would never forgive myself if you left empty handed without trying this incredible system.
            </p>
            <p className="text-gray-800 text-lg mb-4">
              Click The Button Below Right Now And <strong>Save $10</strong> On The Entire Program!
            </p>
            <AffiliateLink className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-lg text-lg transition-colors">
              Grab Your Discount Here
            </AffiliateLink>
            <WatchNowButton className="mt-4" />
          </aside>

        </article>
      </main>

      <Footer />
    </div>
  );
};

export default TSLPage;